import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import MomentUtils from '@date-io/moment';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import * as atatus from 'atatus-spa';

import theme from './theme/theme';
import App from './App';
import history from './history';
import metaPrivate from './metaPrivate.json';

// sets the app version variable to be used in cache invalidation
global.appVersion = metaPrivate.version;

// logging package
if (import.meta.env.PROD) {
  atatus
    .config('945eb4b6d1d74e36bbfaefddc6e0ebc8', {
      // Expected client-side conditions that were the two loudest REI Hub FE error groups:
      // an expired session token surfacing through the feathers socket client, and the benign
      // browser ResizeObserver notice. Neither is actionable, so keep them out of Atatus.
      //
      // The rest are errors thrown by code we do not ship: browser extensions injected into the
      // page, a third-party ad tag, and the Outlook SafeLink scanner's known `Object Not Found
      // Matching Id` bug. None of them are reachable from our source, so they are pure noise.
      ignoreErrors: [
        'jwt expired',
        /ResizeObserver loop/,
        /reading 'M_ID'/,
        /Failed to connect to MetaMask/,
        /Talisman extension has not been configured/,
        /Object Not Found Matching Id/,
        /Unexpected identifier 's'/,
      ],
    })
    .install();
}

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Router history={history}>
        <App />
      </Router>
    </MuiPickersUtilsProvider>
  </MuiThemeProvider>,
  document.getElementById('root'),
);
